<template>
<div class="page-container" v-loading="loading" :element-loading-text="$t('正在加载缓存监控数据')" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
  <el-row :gutter="20">
    <el-col :span="24">
      <el-card class="item-container">
        <div slot="header"><span><i class="el-icon-monitor"></i> {{ $t('基本信息') }}</span></div>
        <div class="el-table el-table--enable-row-hover el-table--medium">
          <table cellspacing="0" style="width: 100%">
            <tbody>
              <tr>
                <td class="el-table__cell is-leaf"><div class="cell">{{ $t('Redis版本') }}</div></td>
                <td class="el-table__cell is-leaf"><div class="cell" v-if="cache.info">{{ cache.info.redis_version }}</div></td>
                <td class="el-table__cell is-leaf"><div class="cell">{{ $t('运行模式') }}</div></td>
                <td class="el-table__cell is-leaf"><div class="cell" v-if="cache.info">{{ cache.info.redis_mode == "standalone" ? $t("单机") : $t("集群") }}</div></td>
                <td class="el-table__cell is-leaf"><div class="cell">{{ $t('端口') }}</div></td>
                <td class="el-table__cell is-leaf"><div class="cell" v-if="cache.info">{{ cache.info.tcp_port }}</div></td>
                <td class="el-table__cell is-leaf"><div class="cell">{{ $t('客户端数') }}</div></td>
                <td class="el-table__cell is-leaf"><div class="cell" v-if="cache.info">{{ cache.info.connected_clients }}</div></td>
              </tr>
              <tr>
                <td class="el-table__cell is-leaf"><div class="cell">{{ $t('运行时间(天)') }}</div></td>
                <td class="el-table__cell is-leaf"><div class="cell" v-if="cache.info">{{ cache.info.uptime_in_days }}</div></td>
                <td class="el-table__cell is-leaf"><div class="cell">{{ $t('使用内存') }}</div></td>
                <td class="el-table__cell is-leaf"><div class="cell" v-if="cache.info">{{ cache.info.used_memory_human }}</div></td>
                <td class="el-table__cell is-leaf"><div class="cell">{{ $t('使用CPU') }}</div></td>
                <td class="el-table__cell is-leaf"><div class="cell" v-if="cache.info">{{ parseFloat(cache.info.used_cpu_user_children).toFixed(2) }}</div></td>
                <td class="el-table__cell is-leaf"><div class="cell">{{ $t('内存配置') }}</div></td>
                <td class="el-table__cell is-leaf"><div class="cell" v-if="cache.info">{{ cache.info.maxmemory_human }}</div></td>
              </tr>
              <tr>
                <td class="el-table__cell is-leaf"><div class="cell">{{ $t('AOF是否开启') }}</div></td>
                <td class="el-table__cell is-leaf"><div class="cell" v-if="cache.info">{{ cache.info.aof_enabled == "0" ? $t("否") : $t("是") }}</div></td>
                <td class="el-table__cell is-leaf"><div class="cell">{{ $t('RDB是否成功') }}</div></td>
                <td class="el-table__cell is-leaf"><div class="cell" v-if="cache.info">{{ cache.info.rdb_last_bgsave_status }}</div></td>
                <td class="el-table__cell is-leaf"><div class="cell">{{ $t('Key数量') }}</div></td>
                <td class="el-table__cell is-leaf"><div class="cell" v-if="cache.dbSize">{{ cache.dbSize }} </div></td>
                <td class="el-table__cell is-leaf"><div class="cell">{{ $t('网络入口/出口') }}</div></td>
                <td class="el-table__cell is-leaf"><div class="cell" v-if="cache.info">{{ cache.info.instantaneous_input_kbps }}kps/{{cache.info.instantaneous_output_kbps}}kps</div></td>
              </tr>
            </tbody>
          </table>
        </div>
      </el-card>
    </el-col>

    <el-col :span="12">
      <el-card>
        <div slot="header"><span><i class="el-icon-pie-chart"></i> {{ $t('命令统计') }}</span></div>
        <div class="el-table el-table--enable-row-hover el-table--medium">
          <div ref="commandstats" style="height: 420px" />
        </div>
      </el-card>
    </el-col>

    <el-col :span="12">
      <el-card>
        <div slot="header"><span><i class="el-icon-odometer"></i> {{ $t('内存信息') }}</span></div>
        <div class="el-table el-table--enable-row-hover el-table--medium">
          <div ref="usedmemory" style="height: 420px" />
        </div>
      </el-card>
    </el-col>
  </el-row>
</div>
</template>

<script>
import { getMonitorInfo } from '../../../api/monitor/cache'
import * as echarts from 'echarts'
import { LANGUAGE_EVENT } from '../../../i18n'

export default {
  name: 'CacheMonitor',

  data () {
    return {
      // 加载框
      loading: false,
      // 统计命令信息
      commandstats: null,
      // 使用内存
      usedmemory: null,
      // cache信息
      cache: []
    }
  },
  created () {
    this.getList()
  },
  methods: {
    // 查缓存询信息
    getList () {
      this.loading = true
      getMonitorInfo().then((res) => {
        this.cache = res

        // 图表文案绘制在 canvas 中，无法被 DOM 文案替换机制覆盖，
        // 这里按当前语言取值，并在语言切换时整体重绘。
        this.commandstats = echarts.init(this.$refs.commandstats, 'macarons')
        this.usedmemory = echarts.init(this.$refs.usedmemory, 'macarons')
        this.renderCharts()
        window.addEventListener('resize', this.resizeCharts)
        window.addEventListener(LANGUAGE_EVENT, this.renderCharts)
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    renderCharts () {
      if (!this.commandstats || !this.usedmemory || !this.cache.info) return
      const en = this.$locale === 'en'
      const used = this.cache.info.used_memory_human
      this.commandstats.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        series: [
          {
            name: en ? 'Command' : '命令',
            type: 'pie',
            roseType: 'radius',
            radius: [15, 95],
            center: ['50%', '38%'],
            data: this.cache.commandStats || [],
            animationEasing: 'cubicInOut',
            animationDuration: 1000
          }
        ]
      }, true)
      this.usedmemory.setOption({
        tooltip: {
          formatter: '{b} <br/>{a} : ' + used
        },
        series: [
          {
            name: en ? 'Peak' : '峰值',
            type: 'gauge',
            min: 0,
            max: 1000,
            detail: {
              formatter: used
            },
            data: [
              {
                value: parseFloat(used),
                name: en ? 'Memory Usage' : '内存消耗'
              }
            ]
          }
        ]
      }, true)
    },
    resizeCharts () {
      if (this.commandstats) this.commandstats.resize()
      if (this.usedmemory) this.usedmemory.resize()
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeCharts)
    window.removeEventListener(LANGUAGE_EVENT, this.renderCharts)
    if (this.commandstats) {
      this.commandstats.dispose()
      this.commandstats = null
    }
    if (this.usedmemory) {
      this.usedmemory.dispose()
      this.usedmemory = null
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  margin-bottom: 20px;

  i {
    margin-right: 5px;
  }
}
.item-container {
  margin-bottom: 20px;
}
</style>
